import { IProgressUpdate, ProgressUpdate } from "./ProgressUpdate";
import { IEntity } from "./Entity";
import { IPartnerOrganisationRisk } from "./PartnerOrganisationRisk";

export interface IPartnerOrganisationRiskUpdate extends IProgressUpdate {
    PartnerOrganisationRiskID: number | null;
    RiskProbabilityID: number | null;
    RiskImpactLevelID: number | null;
    BeisRiskProbabilityID: number | null;
    BeisRiskImpactLevelID: number | null;
    BeisRagOptionID: number | null;
    RiskProximity: Date | null;
    RiskIsOngoing: boolean | null;
    SignOffID: number | null;
    PartnerOrganisationRisk?: IPartnerOrganisationRisk;
    RiskProbability?: IEntity;
    RiskImpactLevel?: IEntity;
    BeisRiskProbability?: IEntity;
    BeisRiskImpactLevel?: IEntity;
}

export class PartnerOrganisationRiskUpdate extends ProgressUpdate implements IPartnerOrganisationRiskUpdate {
    public PartnerOrganisationRiskID: number | null = null;
    public RiskProbabilityID = null;
    public RiskImpactLevelID = null;
    public BeisRiskProbabilityID = null;
    public BeisRiskImpactLevelID = null;
    public BeisRagOptionID = null;
    public RiskProximity = null;
    public RiskIsOngoing = null;
    public SignOffID = null;

    constructor(riskId?: number, period?: Date) {
        super(period);
        if(riskId)
            this.PartnerOrganisationRiskID = riskId;
    }
}